enum AliasStateEnum {
    PUBLIC_ALIAS_INVALID = "PUBLIC_ALIAS_INVALID",
    PUBLIC_ALIAS_EXPIRED = "PUBLIC_ALIAS_EXPIRED",
    PUBLIC_ALIAS_NOT_ACTIVE = "PUBLIC_ALIAS_NOT_ACTIVE",
    PUBLIC_ALIAS_NOT_FOUND = "PUBLIC_ALIAS_NOT_FOUND",
    VERIFIED_MOBILE_NOT_FOUND = "VERIFIED_MOBILE_NOT_FOUND"
}

export default AliasStateEnum;
